import {SubscriptionAppStore,subscriptionAppInitialState} from "./app"
import * as Actions from "./actions"

export const SubscriptionAppReducer = (store:SubscriptionAppStore = subscriptionAppInitialState, action:Actions.SubscriptionAppAction):SubscriptionAppStore => {
	switch(action.type) {
		case 'change to save state':
			return {
				subscriptionId: store.subscriptionId,
				name: store.name,
				optional: store.optional,
				reason: store.reason,
				isSaving: true,
				errorFields: store.errorFields
			}
		case 'field action':
			return fieldReducer(store, (action as Actions.FieldActionWrapper).action)
		case 'save action':
			return saveReducer(store, (action as Actions.SaveActionWrapper).action)
	}
	return store
}

const fieldReducer = (store:SubscriptionAppStore = subscriptionAppInitialState, action:Actions.FieldAction):SubscriptionAppStore => {
	switch(action.type) {
		case 'change name':
			return {
				subscriptionId: store.subscriptionId,
				name: (action as Actions.ChangeNameAction).name,
				optional: store.optional,
				reason: store.reason,
				isSaving: store.isSaving,
				errorFields: store.errorFields
			}
		case 'change optional':
			const optional = (action as Actions.ChangeOptionalAction).optional
			return {
				subscriptionId: store.subscriptionId,
				name: store.name,
				optional: optional,
				reason: store.reason,
				isSaving: store.isSaving,
				errorFields: store.errorFields
			}
		case 'change reason':
			return {
				subscriptionId: store.subscriptionId,
				name: store.name,
				optional: store.optional,
				reason: (action as Actions.ChangeReasonAction).reason,
				isSaving: store.isSaving,
				errorFields: store.errorFields
			}
	}
	return store
}

const saveReducer = (store:SubscriptionAppStore = subscriptionAppInitialState, action:Actions.SaveAction):SubscriptionAppStore => {
	switch(action.type) {
		case 'save add success':
			return {
				subscriptionId: (action as Actions.SaveSuccessAddAction).id,
				name: store.name,
				optional: store.optional,
				reason: store.reason,
				isSaving: false,
				errorFields: []
			}
		case 'save edit success':
			return {
				subscriptionId: store.subscriptionId,
				name: store.name,
				optional: store.optional,
				reason: store.reason,
				isSaving: false,
				errorFields: []
			}
		case 'save failure':
			return {
				subscriptionId: store.subscriptionId,
				name: store.name,
				optional: store.optional,
				reason: store.reason,
				isSaving: false,
				errorFields: (action as Actions.SaveFailureAction).errorFields
			}
	}
	return store
}


// WEBPACK FOOTER //
// ./src/subscriptionmanager/module/subscription-list/reducers.ts